import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'view-design'
import { setToken, getToken, canTurnTo, setTitle, getWechatAuthCode } from '@/libs/util'
import config from '@/config'
import axios from 'axios'

const { homeName } = config

Vue.use(VueRouter)

const router = new VueRouter({
  routes
  // mode: 'history'
})

const LOGIN_PAGE_NAME = 'login'

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next()
  // 有权限，可访问
  else {
    next({
      replace: true,
      name: 'error_401'
    })
  } // 无权限，重定向到401页面
}

router.beforeEach(async (to, from, next) => {
  iView.LoadingBar.start()

  const token = getToken()

  const wechatAuthCode = getWechatAuthCode(location.href)
  if (wechatAuthCode) {
    const { auth_code, expires_in } = wechatAuthCode
    try {
      await axios.get(`https://fresh.chengbao88.com/fresh_chain_admin/wxa/wxa_redirect?auth_code=${auth_code}&expires_in=${expires_in}`)
      location.href = '/#/wechat_mp/wechat_config_success'
    } catch (e) {
      console.error('授权失败')
    }
    return
  }

  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面是登录页
    setToken('')
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    })
  } else {
    const editor = await store.dispatch('editor/getUserInfo')

    turnTo(to, editor.access, next)
  }
})

router.afterEach((to) => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
